import {Controller} from "@hotwired/stimulus";
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

export default class extends Controller {
    static values = {
        dateFormat: {type: String, default: 'F j, Y'},
        minDate: {type: String, default: null},
        maxDate: {type: String, default: null},
        enableTime: {type: Boolean, default: false},
        timeFormat: {type: String, default: 'HH:mm AA'},
        timepicker: {type: Boolean, default: false},
        buttons: {type: Array, default: ['clear']},
        inline: {type: Boolean, default: false},
        position: {type: String, default: 'bottom left'},
        autoClose: {type: Boolean, default: true},
        noCalendar: {type: Boolean, default: false},

    };

    airDatepickerInstance = null;

    connect() {
        console.log("Air Datepicker Stimulus Controller connected! 🗓️");

        const options = {
            locale: localeEn,
            dateFormat: this.dateFormatValue,
            // minDate: this.minDateValue ? new Date(this.minDateValue) : null,
            // maxDate: this.maxDateValue ? new Date(this.maxDateValue) : null,
            buttons: this.buttonsValue,
            inline: this.inlineValue,
            position: this.positionValue,
            autoClose: this.autoCloseValue,
            timepicker: this.timepickerValue || this.enableTimeValue,
            onlyTimepicker: this.noCalendarValue && (this.timepickerValue || this.enableTimeValue),

            onSelect: ({date, formattedDate, datepicker}) => {
                this.element.dispatchEvent(new Event('input', {bubbles: true}));
                this.dispatch("change", {detail: {date: date, formatted: formattedDate}});
            },

        };

        if (this.enableTimeValue) {
            options.timepicker = true;
            options.timeFormat = this.timeFormatValue;
        }

        if (this.noCalendarValue) {
            options.onlyTimepicker = true;
            options.timepicker = true;
        }


        this.airDatepickerInstance = new AirDatepicker(this.element, options);
    }

    disconnect() {
        console.log("Air Datepicker Stimulus Controller disconnected! 👋");
        if (this.airDatepickerInstance) {
            this.airDatepickerInstance.destroy();
            this.airDatepickerInstance = null;
        }
    }

    open() {
        if (this.airDatepickerInstance) {
            this.airDatepickerInstance.show();
        }
    }

    close() {
        if (this.airDatepickerInstance) {
            this.airDatepickerInstance.hide();
        }
    }

    clear() {
        if (this.airDatepickerInstance) {
            this.airDatepickerInstance.clear();
        }
    }

    selectDate(event) {
        const dateToSet = event.params.date;
        if (this.airDatepickerInstance && dateToSet) {
            this.airDatepickerInstance.selectDate(new Date(dateToSet));
        }
    }
}